import { render } from "./BlockStreamAudio.vue?vue&type=template&id=c6b1289e&lang=pug"
import script from "./BlockStreamAudio.vue?vue&type=script&lang=js"
export * from "./BlockStreamAudio.vue?vue&type=script&lang=js"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__